import React from "react";
import { StyledIconDefaultButton } from "./StyledComponents/Buttons";
import { IconDefaultButton } from "./IconDefaultButton";
import { BackgroundEnum } from "../Enums/ThemeEnums";

interface ButtonIconPropsApi {
  id?: string;
  icon: string;
  alt: string;
  onClick?: (event: any) => any;
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
  withShadow?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  withBorder?: boolean;
  bg?: string;
}

interface ButtonClickPropsApi {
  id?: string;
  onClick?: (event: any) => any;
  withShadow?: boolean;
}

export const UpdateDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/pen.svg"
      alt="Изменить"
    />
  );
};

export const DeleteDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      onClick={props.onClick}
      type="button"
      withShadow={props.withShadow}
      icon="/img/trash.svg"
      alt="Удалить"
    />
  );
};

export const SaveDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      onClick={props.onClick}
      type="button"
      withShadow={props.withShadow}
      icon="/img/save.svg"
      alt="Сохранить"
    />
  );
};

export const ShowDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-down.svg"
      alt="Расскрыть"
    />
  );
};

export const CloseDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-top.svg"
      alt="Свернуть"
    />
  );
};

export const TreeLeafShowDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-right-without-back-white.svg"
      alt="Расскрыть"
      bg="transparent"
    />
  );
};

export const TreeLeafCloseDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-down-without-back-white.svg"
      alt="Свернуть"
      bg="transparent"
    />
  );
};

export const ProfileDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="40px"
      width="40px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/user.svg"
      alt="Профиль"
      withBorder
      margin="0px"
    />
  );
};

export const SortAZDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/sort-а-я.svg"
      alt="Сортировать по алфавиту от а до я"
    />
  );
};

export const SortZADefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/sort-я-а.svg"
      alt="Сортировать по алфавиту от я до а"
    />
  );
};

export const SortNoneDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/ellipsis.svg"
      alt="Нет сортировки"
    />
  );
};

export const Sort19DefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      id={props.id}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/sort-1-9.svg"
      alt="Сортировать по возрастанию порядкового номера"
    />
  );
};

const topAndBottomButtonsProp = {
  width: "20px",
  height: "30px",
  margin: "0px",
  padding: "0px",
  bg: "transparent",
};

export const TopDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      {...topAndBottomButtonsProp}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-up-with-tail.svg"
      alt="Переместить выше"
    />
  );
};

export const BottomDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      {...topAndBottomButtonsProp}
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/arrow-down-with-tail.svg"
      alt="Переместить ниже"
    />
  );
};

export const PlusDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      onClick={props.onClick}
      withShadow={props.withShadow}
      icon="/img/plus.svg"
      alt="Добавить"
    />
  );
};

export const MailDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="40px"
      width="40px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/mail.svg"
      alt="Почта"
      margin="0px"
      withShadow={false}
    />
  );
};

export const InfoDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/info.svg"
      alt="Информация"
      margin="0px"
      />
  );
};

export const CrossDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="40px"
      width="40px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/close-svgrepo-com.svg"
      alt="Закрыть"
      margin="0px"
      padding="0px"
      withShadow={false}
      bg={BackgroundEnum.transparent}
    />
  );
};

export const DoorOpenDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/door-open.svg"
      alt="Открыть"
      margin="0px"
    />
  );
};

export const DoorCloseDefaultButton: React.FC<ButtonClickPropsApi> = (
  props: ButtonClickPropsApi
) => {
  return (
    <IconDefaultButton
      height="30px"
      width="30px"
      id={props.id}
      onClick={props.onClick}
      icon="/img/door.svg"
      alt="Закрыть"
      margin="0px"
    />
  );
};
